import { render, staticRenderFns } from "./grossing-touch-sample-tab-portions.vue?vue&type=template&id=e75e38fa&"
import script from "./grossing-touch-sample-tab-portions.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-sample-tab-portions.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-sample-tab-portions.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports